import React from 'react';
import { Link } from 'react-router-dom';
import './AboutBanner.scss';
import bannerOne from '../../assets/about/banner/banner_1.png'
import bannerTwo from '../../assets/about/banner/banner_2.png'
import pattern from '../../assets/banner/pattern.png'

const AboutBanner = () => {
    return (
        <section className='about-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="about-banner-text">
                                    <h2>Hakkımızda</h2>
                                    <p>Ağız ve diş sağlığınızın yılın her günü size güven vermesini istiyoruz; yerken, konuşurken, gülerken ve hayatı paylaşırken kendinizi iyi hissetmeniz için çalışıyoruz.</p>

                                    <div className="theme-btn">
                                        <Link to='/iletisim'>İletişime Geçin</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="about-banner-img">
                                    <img src={bannerOne} alt="hakkımızda görseli"/>
                                    <img src={bannerTwo} alt="hakkımızda ikinci görseli"/>
                                    <img className='pattern' src={pattern} alt="dekoratif desen"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutBanner;